import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicFormService } from '../../../routes/dev-tools/dynamic-form/dynamic-form.service';

@Component({
  selector: 'app-supplier-dynamic-form-value',
  templateUrl: './supplier-dynamic-form-value.component.html',
  styles: [],
})
export class SupplierDynamicFormValueComponent implements OnInit {

  /**
   * 是否编辑
   */
  @Input() isEdit: boolean;
  /**
   *动态表单代码（指明表单类型）
   */
  @Input() dynamicFormCode: string;
  /**
   * 供应商视图传过来的动态表单数据
   * */
  @Input() valueData: any;

  //是否可切换编辑状态
  @Input() isSwitchState;

  @ViewChild('dynamicForm') dynamicForm: NgForm;

  configData: any = {};
  singleLineTables = [];
  multipleLineTables = [];

  constructor(private dynamicFormService: DynamicFormService) {

  }

  //数组排序
  compare(property) {
    return function(a, b) {
      let value1 = a[property];
      let value2 = b[property];
      return value1 - value2;
    };
  }

  tableObjInit() {
    this.tableObj.dynamicFields.forEach(field => {
      if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
        if (!this.editTableFields[field.fieldName]) {
          this.editTableFields[field.fieldName] = {};
        }
      }
    });
  }

  ngOnInit() {
    this.loading = true;
    this.dynamicFormService.getByCode(this.dynamicFormCode).subscribe(configData => {
      this.loading = false;
      this.configData = configData;
      this.singleLineTables = this.configData.dynamicTables.filter(item => item.dataType == 'Single');
      this.multipleLineTables = this.configData.dynamicTables.filter(item => item.dataType == 'Multiple');
      if (this.multipleLineTables.length) {
        this.multipleLineTables.sort(this.compare('orderNumber'));
        this.tableObj = this.multipleLineTables[0];
        this.tableObjInit();
      }
      this.initData();
    }, () => this.loading = false, () => this.loading = false);
  }


  initData(): any {
    if (!this.configData.dynamicTables) {
      return;
    }
    this.configData.dynamicTables.forEach(table => {
      if (!this.valueData) {
        this.valueData = {
          data: {},
        };
      }
      if (!this.valueData.data) {
        this.valueData.data = {};
      }
      if (!this.valueData.data[table.tableName]) {
        if (table.dataType == 'Single') {
          this.valueData.data[table.tableName] = {};
          table.dynamicFields.forEach(field => {
            if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
              if (!this.valueData.data[table.tableName][field.fieldName]) {
                this.valueData.data[table.tableName][field.fieldName] = {};
              }
            }
          });
        } else if (table.dataType == 'Multiple') {
          this.valueData.data[table.tableName] = [];
        }
      } else {
        if (table.dataType == 'Single') {
          table.dynamicFields.forEach(field => {
            if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
              if (!this.valueData.data[table.tableName][field.fieldName]) {
                this.valueData.data[table.tableName][field.fieldName] = {};
              }
            }
          });
        } else if (table.dataType == 'Multiple') {
          table.dynamicFields.forEach(field => {
            if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
              for (let i = 0; i < this.valueData.data[table.tableName].length; i++) {
                if (!this.valueData.data[table.tableName][i][field.fieldName]) {
                  this.valueData.data[table.tableName][i][field.fieldName] = {};
                }
              }
            }
          });
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.valueData && this.valueData) {
      this.initData();
    }
  }

  public validateForm(): boolean {
    for (let item in this.dynamicForm.controls) {
      this.dynamicForm.controls[item].markAsDirty();
      this.dynamicForm.controls[item].updateValueAndValidity();
    }
    if (this.dynamicForm.valid) {
      return true;
    }
    return false;
  }


//  表格
  allChecked = false;
  indeterminate = false;
  displayData = [];
  public selectDatas: any = [];

  currentPageDataChange($event: Array<{ name: string; age: number; address: string; checked: boolean; disabled: boolean; }>): void {
    this.displayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
    this.selectDatas = this.displayData.filter(value => value.checked);
  }

  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  public tableObj: any = {};

  selectTableObj(tableItem) {
    setTimeout(() => {
      this.tableObj = tableItem;
      this.tableObjInit();
    }, 0);
  }

//  弹框
  @ViewChild('tableForm') tableForm: NgForm;
  public modalIsVisible: any = false;
  public editTableFields: any = {};
  public editeIndex: any = -1;

  editTableField(fields?, i?) {
    this.modalIsVisible = true;
    if (fields) {
      this.editTableFields = JSON.parse(JSON.stringify(fields));
      this.editeIndex = i;
    } else {
      this.editTableFields = {};
      this.editeIndex = -1;
    }
    this.tableObjInit();
  }

  deleteTableField() {
    let arr = [];
    for (let i = 0; i < this.valueData.data[this.tableObj.tableName].length; i++) {
      if (!this.valueData.data[this.tableObj.tableName][i].checked) {
        arr.push(this.valueData.data[this.tableObj.tableName][i]);
      }
    }
    setTimeout(() => {
      this.valueData.data[this.tableObj.tableName] = arr;
      this.selectDatas = [];
    }, 0);
  }

  handleCancel() {
    this.modalIsVisible = false;
  }

  handleOk() {
    for (let item in this.tableForm.controls) {
      this.tableForm.controls[item].markAsDirty();
      this.tableForm.controls[item].updateValueAndValidity();
    }
    if (!this.tableForm.valid) {
      return;
    }
    this.modalIsVisible = false;
    if (this.editeIndex == -1) {
      let arr = JSON.parse(JSON.stringify(this.valueData.data[this.tableObj.tableName]));
      arr.push(this.editTableFields);
      this.valueData.data[this.tableObj.tableName] = JSON.parse(JSON.stringify(arr));
    } else {
      let arr = JSON.parse(JSON.stringify(this.valueData.data[this.tableObj.tableName]));
      arr[this.editeIndex] = this.editTableFields;
      this.valueData.data[this.tableObj.tableName] = JSON.parse(JSON.stringify(arr));
    }
  }

  public loading: boolean = false;

  getListData() {
    return this.valueData;
  }
}
